// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"aeb73de8","573":"da18ed66"}[chunkId] + ".chunk.css";
};